import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';
import {
  GetDeveloperTokenRequest,
  GetDeveloperTokenResponse,
  GetOrganizationTokenRequest,
  GetOrganizationTokenResponse,
  PostLoginRequest,
  PostLoginResponse
} from '../models/token';

@Injectable()
export class TokenService {

  constructor(private httpClient: HttpClient) {
  }

  postLogin({email, password}: PostLoginRequest): Observable<PostLoginResponse> {
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    const url = `${environment.mobileAppHost}users/login`;
    const body = {
      email,
      password
    };

    return this.httpClient
      .post<PostLoginResponse>(url, body, {headers});
  }

  getOrganizationToken({accessToken, organizationId}: GetOrganizationTokenRequest): Observable<GetOrganizationTokenResponse> {
    const headers = new HttpHeaders({'Authorization': `Bearer ${accessToken}`});
    const url = `${environment.afbV2Host}orgs/${organizationId}/token`;

    return this.httpClient
      .get<GetOrganizationTokenResponse>(url, {headers});
  }

  getDeveloperToken({organizationToken}: GetDeveloperTokenRequest): Observable<GetDeveloperTokenResponse> {
    const headers = new HttpHeaders({'Authorization': `Bearer ${organizationToken}`});
    const url = `${environment.awairAfbHost}orgs/self/developer/token`;

    return this.httpClient
      .get<GetDeveloperTokenResponse>(url, {headers: headers});
  }
}
